import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheSpiritOfTheMill from "./sections/TheSpiritOfTheMill";
import TheProcess from "./sections/TheProcess";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheSpiritOfTheMill />
      <TheProcess />
      <ContactUs />
      <Footer />
    </div>;
}